import React from "react";
import List from "./List";
import Header from "./Header";
import TaskSearchBar from "./TaskSearchBar";
import useWindowDimensions from "../../helpers/window";

const TaskList = ({
  listId,
  tasks,
  searchTerm,
  setSearchTerm,
  showSearch,
  onSearchToggle,
  userHasTasks,
  compact = false,
  hideTitle = false,
  onOpenTaskHelper,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;
  const title =
    isMobile || compact
      ? "Tasks"
      : listId === "targets"
        ? "Targets"
        : "Backlog";

  return (
    <div className="task-list-container" key={listId}>
      <Header
        title={hideTitle ? "" : title}
        listId={listId}
        onSearchClick={onSearchToggle}
        isSearchActive={showSearch}
      />
      {showSearch && (
        <TaskSearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onClose={onSearchToggle}
        />
      )}
      <List
        tasks={tasks}
        listId={listId}
        searchTerm={searchTerm}
        userHasTasks={userHasTasks}
        compact={compact}
        onOpenTaskHelper={onOpenTaskHelper}
      />
    </div>
  );
};

export default TaskList;
